<div
    class="landing-page__container"
    *ngIf="true"
    fxLayout="column"
    fxLayoutAlign="center center"
>
    <h1 class="landing-page__title">
        {{ "Registration complete" | translate }}
    </h1>
    <div class="landing-page__subtitle">
        <p style="text-align: center; margin-top: -16px; margin-bottom: 16px;">
            {{ "No further action is needed at this time" | translate }}.
        </p>
    </div>
</div>